<template>
	<el-drawer :modal="false"  title="Filter" :visible.sync="drawerFilterLeads" class="drawer-filter-leads" size="20%">

		<b-container>
			<b-row class="text-end">
				<b-col cols="12">
					<div class="d-flex justify-content-end">
						<b-button variant="primary" @click="resetFilter">Reset</b-button>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<b-form-group label="Lead Id">
						<b-form-input type="text" v-model="filter.lead_id" placeholder="Filter By Lead ID"
							@input="debouncedHandler"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Lead Name">
						<b-form-input type="text" v-model="filter.lead_name" placeholder="Filter By Lead Name"
							@input="debouncedHandler"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Lead Contact No.">
						<b-form-input type="text" v-model="filter.contact_no" placeholder="Filter By Contact No."
							@input="debouncedHandler"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Assigned To">
							<el-select v-model="filter.assign_ids" placeholder="Select Team Member" filterable
							@change="searchByFilter()">
							<el-option label="" value="">All</el-option>
							<el-option v-for="(item, key) in userListOpt" :key="key" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter By Channel">
						<el-select v-model="filter.channel" placeholder="Filter By Channel" @change="searchByFilter" multiple
							filterable>
							<!-- <el-option value="">All</el-option> -->
							<el-option v-for="item in channelList" :key="item.channel_id" :label="item.name" :value="item.channel_id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter By Platform">
						<el-select v-model="filter.platform" placeholder="Filter By Platform" @change="searchByFilter" multiple
							filterable>
							<!-- <el-option value="">All</el-option> -->
							<el-option v-for="item in platformList" :key="item.platform_id" :label="item.name"
								:value="item.platform_id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<!-- <b-col cols="12">
					<b-form-group label="Filter By Main Status">
						<el-select v-model="filter.main_status" placeholder="Filter By Main Status" @change="searchByFilter"
							filterable>
							<el-option value="">All</el-option>
							<el-option v-for="item in mainStatusList" :key="item.status_id" :label="item.status"
								:value="item.status_id">
                                </el-option>
                        </el-select>
                    </b-form-group>
                </b-col> -->
				<b-col cols="12">
					<b-form-group label="Filter By Sub Status">
						<el-select v-model="filter.sub_status" placeholder="Filter By Sub Status" @change="searchByFilter" filterable>
							<!-- <el-option value="">All</el-option> -->
							<el-option v-for="item in subStatusList" :key="item.status_id" :label="item.status" :value="item.status_id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter By Date Type">
						<el-select v-model="filter.date_type" placeholder="Select" @change="changeDateType()">
							<el-option value="">-</el-option>
							<el-option v-for="item in dateTypes" :key="item.type_id" :label="item.type" :value="item.type_id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<!-- <b-col cols="12">
					<b-form-group label="Filter By Personal/Company">
						<el-select v-model="filter.type" placeholder="Select" @change="searchByFilter">
							<el-option value="">All Types</el-option>
							<el-option v-for="(item, key) in LEADS_TYPE_FILTER" :key="key" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col> -->
				<b-col cols="12" v-if="filter.date_type">
					<base-input :label="filter.date_type == 1 ? 'Created At' : 'Updated At'">
						<div class="">
							<div class="mb-2">
								<el-date-picker v-model="filter.value1" type="date" placeholder="Date From" value-format="yyyy-MM-dd"
									@change="filterByDate()" />
							</div>
							<div class="mb-2 w-100 text-center">
								To
							</div>
							<div class="">
								<el-date-picker v-model="filter.value2" type="date" placeholder="Date Until" value-format="yyyy-MM-dd"
									@change="filterByDate()" />
							</div>
						</div>
					</base-input>
				</b-col>
			</b-row>
		</b-container>

	</el-drawer>
</template>
<script>
import { Button, Drawer, Select, Option, DatePicker, Switch, Radio, RadioGroup } from 'element-ui'
// import { LEADS_TYPE_FILTER } from '@/assets/js/status.js'
import { mapState, mapActions } from 'pinia'
import { useAccessControlStore } from '@/stores/accessControlStore'
import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	debounce
} from '@/assets/js/httpImports.js'

export default {
	name: 'drawer-filter-leads',
	props: {
		mainStatusList: {
			type: Array,
		},
		subStatusList: {
			type: Array,
		}
	},
	mixins: [
		helperFunctionMixin,
	],
	components: {
		[Button.name]: Button,
		[Drawer.name]: Drawer,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[Switch.name]: Switch,
		[Radio.name]: Radio,
		[RadioGroup.name]: RadioGroup,
	},
	computed: {
		...mapState(useAccessControlStore, ['userList']),
		// subStatusListByMainStatus() {
		// 	let filteredSubStatus = this.subStatusList;
		// 	let selected_main_status = this.filter.main_status;
		// 	if (!_gHlp.isEmpty(selected_main_status)) {
		// 		return filteredSubStatus.filter((x) => {
		// 			return selected_main_status == x.parent_id;
		// 		});
		// 	} else {
		// 		return filteredSubStatus;
		// 	}
		// }
	},
	created() {
		this.fetchChannel()
		this.fetchPlatform()
	},
	mounted() {
		this.fetchUserList();
		this.debouncedHandler = debounce(() => {
			this.searchByFilter();
		}, 1000);
	},
	data() {
		return {
			// LEADS_TYPE_FILTER: LEADS_TYPE_FILTER,
			drawerFilterLeads: false,
			filterBy: {
				staff: '',
				date: '',
				radio1: ''
			},
			filter: {
				lead_id: "",
				lead_name: "",
				sub_status: "",
				// main_status: "",
				created_at: "",
				value1: "",
				value2: "",
				channel: "",
				platform: "",
				assign_ids: "",
				contact_no: "",
				date_type: "",
				date_range: "",
				// type: "",
			},
			hide_duplicate_profile: false,
			debouncedHandler: '',
			channelList: [],
			platformList: [],
			userListOpt: [],
			dateTypes: [
				{
					type_id: 1,
					type: 'Created At',
				},
				{
					type_id: 2,
					type: 'Updated At',
				},
			],
		};
	},
	methods: {
		...mapActions(useAccessControlStore, ['getUsers']),
		viewFilterLeads() {
			this.drawerFilterLeads = !this.drawerFilterLeads;
		},
		searchByFilter() {
			// this.$emit('filter_assigned_to',[this.filter.se, this.filter.ssa, this.filter.sse])
			this.$emit('filter_by', this.filter)
		},
		filterByDate() {
			if (this.filter.value1 && this.filter.value2) {
				this.filter.date_range = `${this.filter.value1},${this.filter.value2}`
				this.searchByFilter()
			} else if (!this.filter.value1 && !this.filter.value2) {
				this.filter.date_range = ''
				this.searchByFilter()
			}
		},
		resetFilter() {
			Object.keys(this.filter).forEach(key => {
				this.filter[key] = ''
			});
			this.searchByFilter()
		},
		fetchChannel() {
			axios.get(services.lookup + 'channel', { headers: getHeader() })
				.then(res => {
					this.channelList = res.data.data
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		fetchPlatform() {
			axios.get(services.lookup + 'platform', { headers: getHeader() })
				.then(res => {
					this.platformList = res.data.data
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		changeDateType() {
			if (!this.filter.date_type) {
				this.searchByFilter()
			} else {
				if (this.filter.value1) {
					this.searchByFilter()
				} else {
					this.filter.value2 = ''
				}
			}
		},
		async fetchUserList(){
			const mlvNumbKey = _gAuth.activeUser('account_info.mlv_numb_key');
			let mlvNumb = '';
			if(!_gHlp.isEmpty(mlvNumbKey)){
				const x = mlvNumbKey.split('.');
				mlvNumb = parseInt(x[x.length - 1]);
			}
			if(_gHlp.isEmpty(this.userList))	{
				await this.getUsers(_gAuth.activeCorporateId());
			}
			if (_gHlp.checkAccess(['l_lead__all_record'])){
				this.userListOpt = this.userList.filter((item) => { return item.status === 1 });
			} else {
				this.userListOpt = this.userList.filter((item) => { return item.current_user_application.mlv_numb_key.includes(mlvNumb) && item.status === 1});
			}
		}
	}
}
</script>